import { animate, state, style, transition, trigger } from '@angular/animations'
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { MatSelectChange, MatTableDataSource } from '@angular/material'
import * as _ from 'lodash'
import { isArray } from 'lodash'
import { Subject } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { InputLabelPipe } from '../../../../../pipes/atyl/inputLabel.pipe'
import { DialogService, StateService,FormulaireService } from '../../../../../services'
import { FormAtylBase,ForAtylInputBase } from '../../../../form-atyl-base'
import { AtylService } from '../../../../service/atyl.service'
import { FormDialogFormulaireWithSFComponent } from '../../../form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component'
import { LoadDialogComponent } from '../../../../../views/partials/layout/dialogs/load-dialog/load.component'

import * as moment from 'moment'  ;

@Component({
	selector: 'atyl-form-input-selectionlist',
	templateUrl: './form-input-selectionlist.component.html',
	styleUrls: ['./form-input-selectionlist.component.scss'],
	animations: [
		trigger('detailExpand', [
			state('collapsed', style({ height: '0px', minHeight: '0' })),
			state('expanded', style({ height: '*' })),
			transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
		])
	]
})
export class FormInputSelectionlistComponent extends ForAtylInputBase implements OnInit {

	@Input() forminput: FormAtylBase<any>
	@Input() group: FormGroup
	@Input() isValid: boolean
	@Input() errorMessage: any
	@Input() outline: any
	@Input() disabled: boolean

	@Output() inputTyped = new EventEmitter<any>();
	label: string
	errorString: string

	tiersID: any = null;
	filteredSelectionList: any = [];
	columns: any = [];
	@ViewChild('places', { static: false }) places
	displayedColumns: any

	inited = new EventEmitter<any>();
	data: any = [];
	length = 0;

	dataSource = new MatTableDataSource();



	addSelection: any
	Pagination = 0;
	currentPage = 0;

	isEditable = true;
	autocompSelectList: any
	tempResSelectList: any
	listCardSelectionList: any = [];
	allExpand = false;
	expandedElement: any

    strRecherche:string=null;
    currentTypeList:string = null;
    optionSearch: any = null;
    addSelectionsGeneral: any = null;
    addSelectionsChoice: any = [];
    selectedRelation: any = null;
	private debounce: Subject<any> = new Subject();

	loading:boolean=false;
  	groupedOptions: any = [];

	
	formAction: FormGroup;
	expandedForm: boolean = false;
	expandedFormRow: any;

	 action_date_debut:any;
	 action_date_fin:any;
	 action_motif:string;
	 configHTML: any = {
	         height: '100px',
	         width: '100%',
	         lang: "fr-FR",
	         dialogsInBody: true,
	         toolbar: [
	             
	             ['style',['bold', 'italic', 'underline']],
	             ['alignment',['ul', 'ol']],
	             
	             
	         ]
	 };
	
	 isDisplayExport:boolean=false;
	 isExportCSV:boolean=false;
	 isExportPDF:boolean=false;
	  
	 relationList:any
	 relationsList:any={};
	 
	constructor(
		private stateService: StateService,
		private atylService: AtylService,
		private cdr: ChangeDetectorRef,
		private dialogService: DialogService,
		private inputLabelPipe: InputLabelPipe,
		private formulaireService : FormulaireService
	) {
        super();
	}


	ngOnInit(): void {
        console.log("this.forminput",this.forminput)
		this.emitReadyEvent(false,this.forminput);
		
		if (this.forminput.optionsDefault!=undefined && this.forminput.optionsDefault.export!=undefined 
								&& this.forminput.optionsDefault.export
								&& Array.isArray(this.forminput.optionsDefault.export)
			) {
				
				this.isExportPDF=(this.forminput.optionsDefault.export.includes("PDF"));
				this.isExportCSV=(this.forminput.optionsDefault.export.includes("CSV") || this.forminput.optionsDefault.export.includes("XLSX"));
				this.isDisplayExport=(this.isExportPDF || this.isExportCSV) ;				
			}
		
		
		this.debounce.pipe(
			debounceTime(1000)
		).subscribe((search) => {
			console.log("search",search);
			const searchStr = search['searchStr'];
			if (searchStr.length > 0) {
				this.atylService.getListeSelection(this.forminput.optionsDefault['typelist'], searchStr,null,this.forminput.options).subscribe((result: JSONRpcResponse) => {
					let keyName = ''
					_.forEach(result.result.columns, (column, index) => {
						if (column.primary)
							keyName = column.id
					})
					let autoList = []
					_.forEach(result.result.datas.datas, (data, index) => {
						var searchStr2 = data.search_2 != undefined ? data.search_2 : "";
						autoList.push({
						  key: data[keyName],
						  value: "<div class='text-truncate font-weight-bold'>" + data.search + "</div>" +
							"<div class='text-truncate' title='" + searchStr2 + "'>" + searchStr2 + "</div>",
						  relation: data["relation_code"],
						  tiersAssociate: data["tiersAssociate"]
						});
					  });
					this.autocompSelectList = autoList
					this.tempResSelectList = result.result
					this.tempResSelectList.keyName = keyName
					this.groupOptions();

					if(search['dossierAddedID']){
						var idxData = result.result.datas.datas.findIndex(data=>data.id == search['dossierAddedID']);
						if(idxData != -1){
							this.addToSelectionList(this.autocompSelectList[idxData],this.forminput);
							this.strRecherche = "";
						}
					}
					this.cdr.detectChanges()
				})
			}

		})
		this.label = this.inputLabelPipe.transform(this.forminput.label)
		this.errorString = this.errorMessage && this.errorMessage[0] ? this.errorMessage[0] : ''
		if (this.forminput.optionsDefault.action!==undefined)
	      	this.addcontrols();
	    
	  }
	  
	  addcontrols() {
		/*this.form.addControl("action_date_debut",new FormControl());
		this.form.addControl("action_date_fin",new FormControl());
		this.form.addControl("action_motif",new FormControl());*/_
		
		 this.formAction = new FormGroup({
	            'action_date_debut': new FormControl(''),
	             'action_date_fin': new FormControl(''),
	              'action_motif': new FormControl('')
	        });
		
	  }

  groupOptions() {
	this.groupedOptions = [];
    const groupTiers = { label: 'Tiers', options: [] };
    const groupTiersAsso = { label: 'Tiers Associés', options: [] };

    this.autocompSelectList.forEach(option => {
    if (option.tiersAssociate === false) 
      groupTiers.options.push(option);
    else
      groupTiersAsso.options.push(option);
    });
	if(groupTiers.options.length > 0)
		this.groupedOptions.push(groupTiers);
	if(groupTiersAsso.options.length > 0)
		this.groupedOptions.push(groupTiersAsso);

  }

	customBehaviourHandler(customBehaviour: any) {
		this.inputTyped.emit(customBehaviour)
	}
	ngOnChanges() {
		this.updateDossier()
		if (this.forminput.value && this.forminput.optionsDefault.type === 'listwithinput') {
			this.forminput.optionsDefault.expanders = []
			this.forminput.value.forEach((val, index) => {
				let expander = {}
				val.indexRow = index
				if (Array.isArray(this.forminput.options)) {
					this.forminput.options.forEach((inputToDeclare) => {
						expander[inputToDeclare.ID] = new FormControl(val[inputToDeclare.ID] ? val[inputToDeclare.ID] : '')
					})
					let expanderToPush = new FormGroup(expander)
					this.forminput.optionsDefault.expanders.push(expanderToPush)
					expanderToPush.valueChanges.subscribe((valChanged) => {
						val = Object.assign(val, valChanged)
					})
				}

            })
        }
        this.filteredSelectionList = this.forminput.value ? Array.from(this.forminput.value) : []
		let _opts:any= Object.assign({},this.forminput.options);
			_opts["no_data"]	=true;
        this.atylService.getListeSelection(this.forminput.optionsDefault['typelist'], '', this.tiersID,_opts).subscribe((res: JSONRpcResponse) => {
            this.columns = res.result.columns
			
			if ( this.forminput.optionsDefault.hide_columns!=undefined 
						&& this.forminput.optionsDefault.hide_columns
						&& Array.isArray(this.forminput.optionsDefault.hide_columns)
					 ) {
						for (let i = 0; i < this.forminput.optionsDefault.hide_columns.length; i++) {
							if (this.columns[this.forminput.optionsDefault.hide_columns[i]]!=undefined)
								this.columns[this.forminput.optionsDefault.hide_columns[i]].visible=false;
						}
						
			}
			
			if (res.result.relation!=undefined &&res.result.relation ) {
				this.relationList=res.result.relation;
			}
			
			if ( res.result.relations!=undefined &&res.result.relations
			 && Object.keys(res.result.relations).length>0 ) {
				this.relationsList=res.result.relations;
			}
			/*if (
				 this.forminput.options.options.relations != undefined
				 && this.forminput.options.options.relations
				 && this.forminput.options.options.relations.length>0
				&& res.result.relations!=undefined &&res.result.relations
				 && Object.keys(res.result.relations).length>0 ) {
				let rll:string[]= Object.keys(res.result.relations);
				for (let i = 0; i < rll.length; i++) {
					for (let j = 0; j < this.forminput.options.options.relations.length; j++) {
						if (this.forminput.options.options.relations[j].code!=undefined && this.forminput.options.options.relations[j].code==rll[i] )
							this.forminput.options.options.relations[j].objet=res.result.relations[rll[i]];
					}
				}	
				
				console.log("FormInputSelectionlistComponent relations",this.forminput.options.options.relations)
			}*/

			console.log("FormInputSelectionlistComponent relation",this.relationList,this.relationsList)
			
            this.columns.forEach((column) => {
                if (column.id === 'direction') {
                    column.directions = res.result.options.directions
                }
            })
            this.columns.push({ 'id': 'Remove', 'label': '', 'visible': 'true' })
            this.displayedColumns = this.columns.map(x => x.id)
            this.getDataPage(0, true)
            this.inited.emit(res.result)
            if (res.result.options.add) {
                if(this.forminput.options.typelist == "General"){
					this.addSelectionsGeneral = res.result.options.add;
                }
                else{
                    this.addSelection = res.result.options.add;
                }
            }
            if (this.forminput.options.typelist == "General" && this.forminput.options.options.relations != undefined &&  this.forminput.options.options.relations.length === 1) {
                this.selectedRelation = this.forminput.options.options.relations[0];
                this.changeSelectedRelation(this.forminput.options.options.relations[0]);
            }
            this.cdr.detectChanges();
			this.emitReadyEvent(true,this.forminput);
        })
	}
	getDataPage(page: number = 0, init: boolean = false) {
		this.data = []
        if(this.forminput.options.typelist == "General"){
            this.filteredSelectionList = this.sortDataPageByRelation();
        }
		this.dataSource.data = this.filteredSelectionList
		this.data = this.filteredSelectionList
		this.length = this.filteredSelectionList.length
		this.currentPage = 0
		this.Pagination = 5


		this.cdr.detectChanges()
	}
	
	
	
	triggerAutocompSelectionList(search: any, nameinput: string, dossierAddedID: any = null) {
		const searchObj = {
			searchStr: search,
			dossierAddedID: dossierAddedID
		}
		this.debounce.next(searchObj)
	}
	displayAutoSelectList(key?: any): string | undefined {
		let selected
		if (this.autocompSelectList) {
			this.autocompSelectList.forEach((select) => {
				if (select.key === key)
					selected = select
			})
		}
		return selected ? selected.search : undefined
	}
	
	existOnList(elem: any,input: any) {
		let exist:boolean=false;
		if(input.optionsDefault.type !== "card"){
			_.forEach(this.filteredSelectionList, (res, index) => {
                if (!exist && res[this.tempResSelectList.keyName] === elem.key){
                    if(elem != undefined && elem["relation"] != undefined &&  elem["relation"] 
                    && res["relation_code"] != undefined && res != undefined && res["relation_code"] 
                    && elem["relation"] == res["relation_code"])
                    {
                        exist=true;
                    }
                }	
			});
		}	
		return exist;
	}
	
	addToSelectionList(elem: any, input: any) {
        
		console.log("addToSelectionList",elem, input,
		this.dataSource.data,
		this.filteredSelectionList,
		this.tempResSelectList,elem)
	if (!this.existOnList(elem,input)) {
		_.forEach(this.tempResSelectList.datas.datas, (res, index) => {
	      if(res[this.tempResSelectList.keyName] === elem.key)
	      {
	        if(input.type === "selectionlist" && input.optionsDefault.type !== "card"){
	          
	          if(input.optionsDefault.type === "listwithinput"){
	            let expander = {};
	            res.indexRow = this.filteredSelectionList.length;
	            if(Array.isArray(this.forminput.options)){
	              if(this.forminput.optionsDefault && this.forminput.optionsDefault.expanders === undefined)
	                this.forminput.optionsDefault.expanders = [];
	              this.forminput.options.forEach((inputToDeclare) => {
	                expander[inputToDeclare.ID] = new FormControl('');
	              });
	              let expanderToPush = new FormGroup(expander);
	              this.forminput.optionsDefault.expanders.push(expanderToPush);
	              expanderToPush.valueChanges.subscribe((valChanged) => {
	                res = Object.assign(res, valChanged);
	              });
	            }
	          }
	          this.filteredSelectionList.push(res);
	          (this.group.controls[input.ID] as FormControl).setValue(this.dataSource.data);
	         // this.utilities.log(this.filteredSelectionList, this.group.controls[input.ID]);
	          this.getDataPage();
	          this.inited.emit(this.filteredSelectionList);
	        }
	        else if(input.optionsDefault.type === "card"){
	          this.listCardSelectionList.push(res);
	          this.cdr.detectChanges();
	        }
	      }
	    });
	   }
	}
	dialogAddSelection(nameinput: any) {
		console.log("FormInputSelectionlistComponent dialogAddSelection",this.addSelection,this.forminput.dossier,this.forminput.tiers); 
		const dialogRef=this.dialogService.open(FormDialogFormulaireWithSFComponent, {
			data: {
				/*'typeFormulaire': this.addSelection.params.type,
				'create': true,
				'closeWhenValidate': true
				*/
				 idAForm: this.addSelection.params.idForm,
				 noCreateWithDossier: true,
              /*   dossier:  this.forminput.dossier,    */
                              
                create: true,
                closeWhenValidate: true,
                v3: true,
			},
			height: '90vh',
			width: "90vw",
			maximizable: true,
			minimizable: true,
			draggable: true
		})
		
		if (dialogRef) {
			 dialogRef.afterClosed().subscribe((response: JSONRpcResponse) => {
	      		if(response && response.result){
					console.log("FormInputSelectionlistComponent2 response",response.result);
					if (response.result.ID!=undefined) {
			            this.atylService.getFormulaireByIDOption(response.result.ID).subscribe((res: JSONRpcResponse) =>{
	                        console.log("FormInputSelectionlistComponent2 get response",res);
	                        if(res.result){
	                            let tiers:any=res.result.demande.dossier.tiers;
								this.strRecherche = tiers.NOM;
								let dossierAddedID = res.result.demande.dossier.ID;
	                           	console.log("FormInputSelectionlistComponent search",this.strRecherche, dossierAddedID);
	                           	this.triggerAutocompSelectionList(this.strRecherche,this.forminput.ID,dossierAddedID)
	                            this.cdr.detectChanges();
	                        }
	                   })
	                }
				}
				
				
			});
		}
	}
	expandAllRows() {
		this.allExpand = !this.allExpand
		this.dataSource.data.forEach((row: any) => {
			row.expanded = this.allExpand
		})
	}
	getInitedEmitter() {
		return this.inited
	}
	onPaged(table: any) {
		this.getDataPage(table.currentPage)
	}
	onRowClicked(row: any) {
		row.expanded = row.expanded ? !row.expanded : true
		this.expandedElement = this.expandedElement === row ? null : row
	}
	
	actionLine(cell: any, nameinput: string, expanderIndex: string) {
		console.log("dialog Action",cell);
		if (cell.Action!=undefined && cell.Action=="FORM"
		&& cell.Action_form!=undefined
		)
		{
			this.dialogService.open(FormDialogFormulaireWithSFComponent, {
				data: {
					
					 idAForm: cell.Action_form,
	                 dossier:  "",                    
	                create: true,
	                closeWhenValidate: true,
	                v3: true,
				},
				height: '90vh',
				width: "90vw",
				maximizable: true,
				minimizable: true,
				draggable: true
			})
		} else
			this.onActionClicked(cell);
	}
	
	removeLine(cell: any, nameinput: string, expanderIndex: string) {

		let indexRemove
		this.filteredSelectionList.forEach((row, index) => {
			if (row.id == cell.id) {
				indexRemove = index
			}
		})
		if (expanderIndex !== undefined)
			this.forminput.optionsDefault.expanders.splice(expanderIndex, 1)
		this.filteredSelectionList.splice(indexRemove, 1);
		(this.group.controls[nameinput] as FormControl).setValue(this.filteredSelectionList)
		this.getDataPage()
		this.inited.emit(this.filteredSelectionList)
	}
	updateDossier() {
		this.stateService.dossier.subscribe((dossier: any) => {
			if (dossier.tiers != undefined || dossier.tiers != null) {
				this.tiersID = dossier.tiers.ID
			}
		})
	}
	
	onCellChanged(cell: any) {
        
        var id=cell.column.id+"_"+cell.row.id
        console.log("onCellChanged",id,cell);
        if (document.getElementById(id)) {
            let elt=document.getElementById(id);
         }   
            
    }   
     
	onCellClicked(cell: any) {
        
        var id=cell.column.id+"_"+cell.row.id
      //  console.log("onCellClicked",id,cell);
        if (document.getElementById(id)) {
            let elt=document.getElementById(id);
            let eltCheked=document.querySelector('input[id="'+id+'"]:checked');
          //  console.log("onCellClicked HTML",elt, document.querySelector('input[id="'+id+'"]:checked'));
            
             let eltAlltCheked=document.querySelector('input[name="'+cell.column.id+'"]');
             console.log("onCellClicked ALL HTML",elt, eltAlltCheked,this.group);
            
             if (eltCheked) {
                cell.row[cell.column.id+"_value"]=elt.getAttribute("value");
                elt.setAttribute("checked","checked");
               
            } else
                elt.removeAttribute("checked")
            console.log("onCellClicked HTML",elt.outerHTML, document.querySelector('input[id="'+id+'"]:checked')); 
           
           
            cell.row[cell.column.id]=elt.outerHTML;
            cell.row[cell.column.id+"_checked"]=elt.getAttribute("checked");
            cell.row[cell.column.id+"_value"]=elt.getAttribute("value");
           // cell.row[cell.column.id+"_value"]=elt.getAttribute("value");;
           
           Object.keys(this.group.controls).forEach(key => {
			      if (key!=this.forminput.ID) {
					  let val:any=this.group.get(key).value;
					  console.log("onCellClicked field begfore",key,Array.isArray(val), val);
					  let modify:boolean=false;
					  if (Array.isArray(val)) {
						  let reg:any=/ checked=\"checked\"/
						  for(let i:number=0;i<val.length;i++) {
							  if (val[i][cell.column.id+"_value"]!=undefined) {
							   	val[i][cell.column.id+"_value"]=null;
							   	modify=true;
							   	}
							   if (val[i][cell.column.id+"_checked"]!=undefined) {
							   	val[i][cell.column.id+"_checked"]=null; 
							   	modify=true;
							   	}	
							   if (val[i][cell.column.id]!=undefined) {
								   val[i][cell.column.id]=val[i][cell.column.id].replace(reg, ''); 
							   	modify=true;
							   		
							   }
						  }
						  
						  
					  }
					  if (val.same_address!=undefined) {
						  let vll:any=val;
						  vll.same_address=0;
						  if (vll.zones==undefined)
						  	vll.zones=[];
						  if (vll.num==undefined)
						  		vll.num="";
						  if (vll.comp==undefined)
						  	vll.comp="";
						  if (vll.rue==undefined)
						  	vll.rue="";	
						  this.group.get(key).setValue(vll);
						  val=this.group.get(key).value;
						//  console.log("onCellClicked field begfore address",key,Array.isArray(val), val);
					  
					  }
				  	 console.log("onCellClicked field",key,Array.isArray(val), val);
				  	 if (modify)
				  	 	this.group.get(key).setValue(val);
				     
				  }        
			});
          
           
          }
    }
    
	getSubmittedEmitter() {
        return false;
    }
    
    onLoaded(loaded: boolean){
        if(loaded)
            this.cdr.markForCheck();
    }
    
    
    changeValue(value:any) {
        console.log("changeValue",value);
    }

    onTypeListChange(event: MatSelectChange) {
        this.changeSelectedRelation(event.value);
    }

    changeSelectedRelation(relationParams){
		console.log("changeSelectedRelation",relationParams);
		this.relationList=undefined
		if (relationParams.code!=undefined
			&& this.relationsList[relationParams.code]!=undefined
		)
			this.relationList=this.relationsList[relationParams.code];
		
        this.forminput.options.searchOptions = relationParams;
        this.autocompSelectList = [];
		this.groupedOptions = [];
        this.addSelectionsChoice = this.addSelectionsGeneral[relationParams.code] != undefined? this.addSelectionsGeneral[relationParams.code]: [];
        this.addSelection  = this.addSelectionsChoice.length>0? this.addSelectionsChoice[0]: null;
    }

    sortDataPageByRelation() {
        const newList = [];
        this.forminput.options.options.relations.forEach(element => {
          const filteredTiers = this.filteredSelectionList.filter(tiers => tiers.relation_code === element.code);
          newList.push(...filteredTiers);
        });
        return newList;
    }
	
	onHeaderClicked(sort: any) {
	   let sortList:any = {
	        id: sort.active,
	        direction: sort.direction.toUpperCase(),
			type: "text"
	    }
		
		for(let i:number=0;i<this.columns.length;i++) {
			if (this.columns[i].id!=undefined 
				&& this.columns[i].id ==sortList.id
				 && this.columns[i].type!=undefined  )
				sortList.type=this.columns[i].type;
		}
		
		let tbl:any[]=JSON.parse(JSON.stringify( this.data));
		console.log("onHeaderClicked",tbl,sortList,sort)
		if ( sortList.direction!='') {
		   	 this.data=this.trierTableau(tbl,sortList);
			
		}
		this.loading=false;
		this.cdr.detectChanges();	
	}
	
	trierTableau(tableau,sortList) {
			
			
			
			if (sortList["direction"] === "ASC") 
				  return tableau.sort(this._alphabetically(true,sortList["id"],sortList["type"]));
			else if (sortList["direction"] === "DESC")
			    return tableau.sort(this._alphabetically(false,sortList["id"],sortList["type"]));
			else 
				 return tableau;
			 
	    }

	_alphabetically(ascending,cle,type) {
	//	console.log("onHeaderClicked _alphabetically",ascending,cle,type);
		  return function (a, b) {
		    // equal items sort equally
		    if (a[cle] === b[cle]) {
		        return 0;
		    }

		    // nulls sort after anything else
		    if (a[cle] == undefined ||  a[cle] === null) {
		        return 1;
		    }
		    if (b[cle] == undefined ||  b[cle] === null) {
		        return -1;
		    }
			///console.log("onHeaderClicked _alphabetically 2",a[cle],b[cle],type)
            if (type=="date") {
				
				let am:any={_isValid:false};
				let bm:any={_isValid:false};
								
				
				am=moment(a[cle],'DD/MM/YYYY');
				bm=moment(b[cle],'DD/MM/YYYY');
				//console.log("onHeaderClicked _alphabetically date",a[cle],b[cle],ascending,am,bm)
								
				if (am instanceof moment && am["_isValid"]!=undefined && am["_isValid"]
					&& bm instanceof moment &&  bm["_isValid"]!=undefined && bm["_isValid"]) {
					if (ascending) {
						        return am <  bm ? -1 : 1;
						    }

				    // if descending, highest sorts first
				    return am < bm ? 1 : -1;
					
				}	else {
					
					 am=moment(a[cle],'YYYY-MM-DD');
					 bm=moment(b[cle],'YYYY-MM-DD');
					 if (am instanceof moment && am["_isValid"]!=undefined && am["_isValid"]
					 			&& bm instanceof moment &&  bm["_isValid"]!=undefined && bm["_isValid"]) {
					 					if (ascending) {
					 						        return am <  bm ? -1 : 1;
					 						    }

					 				    // if descending, highest sorts first
					 				    return am < bm ? 1 : -1;
					 					
					 	}	else {
							
						if (ascending) {
								        return new Date(a[cle]) < new Date(b[cle]) ? -1 : 1;
								    }
		
						    // if descending, highest sorts first
						    return new Date(a[cle]) < new Date(b[cle]) ? 1 : -1;
					}		
				}		
			}
			else if (type=="numeric") {
				console.log("_alphabetically",Number(a[cle]),new Number(b[cle]))
				if (ascending) {
						        return new Number(a[cle]) < new Number(b[cle]) ? -1 : 1;
						    }

				    // if descending, highest sorts first
				    return new Number(a[cle]) < new Number(b[cle]) ? 1 : -1;
			}
			 else {
			    // otherwise, if we're ascending, lowest sorts first
			    if (ascending) {
			        return a[cle] < b[cle] ? -1 : 1;
			    }
	
			    // if descending, highest sorts first
			    return a[cle] < b[cle] ? 1 : -1;
			}
		   };
		}
		
		onActionClicked(row:any) {
		      console.log("FormInputSelectionlistComponent onActionClicked",row)
		      this.expandedForm= !this.expandedForm;
		      this.expandedFormRow=row;
		      
		      if (this.expandedFormRow["action"]!=undefined) {
			   console.log("FormInputSelectionlistComponent onActionClicked action",this.expandedFormRow["action"])
			  if (this.expandedFormRow["action"].date_debut!=undefined
			  && this.expandedFormRow["action"].date_debut
			  && this.formAction.get("action_date_debut")
			  )
			    this.formAction.get("action_date_debut").setValue(moment(this.expandedFormRow["action"].date_debut,'DD/MM/YYYY'));
			  if (this.expandedFormRow["action"].date_fin!=undefined
			  && this.expandedFormRow["action"].date_fin
			  && this.formAction.get("action_date_fin")
			  )
			    this.formAction.get("action_date_fin").setValue(moment(this.expandedFormRow["action"].date_fin,'DD/MM/YYYY'));
			  if (this.expandedFormRow["action"].motif!=undefined
			    && this.expandedFormRow["action"].motif
			    && this.formAction.get("action_motif")
			  )
			    this.formAction.get("action_motif").setValue(this.expandedFormRow["action"].motif);
			   
		   }
		      
		      
		       this.cdr.detectChanges();
		}
		
		onCloseActionForm(event:any,onlyclose:boolean=false) {
				  if (!onlyclose) {
					  let begin:any=null;
					  let end:any=null;
					  console.log("FormInputSelectionlistComponent onCloseActionForm",this.formAction.value)
					  if (this.formAction.value["action_date_debut"] instanceof Date )
					      begin=this.formAction.value["action_date_debut"].toLocaleDateString("fr-FR");
				      if (this.formAction.value["action_date_debut"] instanceof moment)
						begin=moment(this.formAction.value["action_date_debut"]).format('DD/MM/YYYY');
					  /*  begin=this.formAction.value["action_date_debut"].getDate()+
					    "/"+this.formAction.value["action_date_debut"].getMonth()+
					     "/"+this.formAction.value["action_date_debut"].getFullYear();
					  */
					if (this.formAction.value["action_date_fin"] instanceof Date )
						end=this.formAction.value["action_date_fin"].toLocaleDateString("fr-FR");
					if (this.formAction.value["action_date_fin"] instanceof moment)
						end=moment(this.formAction.value["action_date_fin"]).format('DD/MM/YYYY');
					  /*  end=this.formAction.value["action_date_fin"].getUTCDate()+
					    "/"+this.formAction.value["action_date_fin"].getUTCMonth()+
					     "/"+this.formAction.value["action_date_fin"].getFullYear();   
					     */
					  let action:any ={
						  date_debut:begin,
						  date_fin:end,
						  motif:this.formAction.value["action_motif"]
						  
						  
					  }
					  this.expandedFormRow["action"]=action;
					  console.log("FormInputSelectionlistComponent OnCloseActionForm",event,
					  action,this.data
					  );
				  }
				  this.expandedForm= !this.expandedForm;
				  
				  
				  
				  
				   this.cdr.detectChanges();
			}
	  
		exporter(format:string) {
			  let ids:any[]=[];_
			  for(let i=0;i<this.data.length;i++) {
				let dt:any=this.data[i];
				if (dt["tiers.id"]!=undefined) {
					ids.push(dt["tiers.id"]);
				} else {
					if (dt["ID"]!=undefined) 
						ids.push(dt["ID"]);
				};
			  }
			if (ids.length>0) {
				let _options:any =(this.forminput.options!=undefined && this.forminput.options.options!=undefined) ?
						Object.assign({},this.forminput.options): {};
				_options["dossier"]=(this.forminput.dossier!=undefined) ? this.forminput.dossier : null;
				_options["ids"]=ids;
				_options["format"]=format;
				   this.loading = true;
				   console.log('before export',_options);
				   this.atylService.getListSelectionExport(this.forminput.optionsDefault['typelist'], _options)
				     .subscribe(  (myexport) => {
				       this.loading = false;
				       console.log('export',myexport);
				       
				       if (myexport.result!=undefined
				        && myexport.result.datas!=undefined
				        && myexport.result.datas.file!=undefined) {
							const dial=this.dialogService.open(LoadDialogComponent, {
									               data: {
									                   url: myexport.result.datas.file
									               },
												   height: "95vh",
												   width: "80%",
												   minimizable: true,
												   maximizable: true,
												   draggable: true,
									           }, (res: any) => {
									               
									           })
							
				            //window.open(myexport.result.datas.file, '_blank');
							
						}	
				       this.cdr.detectChanges();
				   });
				 }
			}
			
			getRelationIcon(relation:any) {
				console.log("FormInputSelectionlistComponent getRelationIcon",relation)
				return (relation.icone!=undefined) ? relation.icone : null;
			}	 


			getRelationColor(relation: any, type:string="background"): any {
				console.log("DossierFoyerComponent getRelationColor",relation)
				let style:any={};
				if (relation.rgb!=undefined)
					style[type]="rgba("+ relation.rgb.r +","+ relation.rgb.g +","+ relation.rgb.b +","+ relation.rgb.a+")";
				return style;
			}

			getRelationColorAttibute(relation: any, type:string="background"): any {
				
				let style:any={};
				if (relation.rgb!=undefined)
					style[type]="rgba("+ relation.rgb.r +","+ relation.rgb.g +","+ relation.rgb.b +","+ relation.rgb.a+")";
				
				let st:string="";
				if (style[type]!=undefined)
					st=type+":"+style[type] +" !important;";
				return st;
			}
				 
}
